
const getTitle = (website: string): string => {
    if (website && website.includes("yoonly")) {
        return "Yoonly"
    }
    return "Travelski"
}

export default getTitle
